<template>
  <b-modal v-model="vModel" size="lg" hide-footer title="Demande de réception">
    <!-- Demandeur -->
    <div
      v-if="
        (userConnected.roles.includes('ROLE_DEMANDEUR') &&
          request.state.id == 4) ||
          (userConnected.roles.includes('ROLE_DEMANDEUR') &&
            request.state.id == 12) ||
          (userConnected.roles.includes('ROLE_ADMIN') &&
            request.state.id == 4) ||
          (userConnected.roles.includes('ROLE_ADMIN') && request.state.id == 12)
      "
    >
      <div class="info-reception">
        <b-row>
          <b-col
            lg="12"
            md="12"
            sm="12"
            cols="12"
            style="font-weight:500;font-size:16px;"
          >
            <font-awesome-icon
              icon="info-circle"
              class="mr-2"
              size="lg"
            ></font-awesome-icon>
            La réception se fait par photos.
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col lg="4" md="12" sm="12" cols="12">
          <label class="control-label"
            >Photo <span class="red">*</span> :</label
          >
        </b-col>
        <b-col lg="6" md="12" sm="12" cols="12">
          <b-form-file
            browse-text="Ouvrir"
            v-model="piece3.file"
            placeholder="Choisissez un fichier ou glissez le ici..."
            drop-placeholder="Glissez un Fichier ici..."
            accept="image/jpeg, image/bmp, image/png, application/pdf"
          ></b-form-file>
        </b-col>
        <b-col lg="4" md="12" sm="12" cols="12">
          <label class="control-label"
            >Photo supplémentaire <span class="red">*</span> :</label
          >
        </b-col>
        <b-col lg="6" md="12" sm="12" cols="12">
          <b-form-file
            browse-text="Ouvrir"
            v-model="piece4.file"
            placeholder="Choisissez un fichier ou glissez le ici..."
            drop-placeholder="Glissez un Fichier ici..."
            accept="image/jpeg, image/bmp, image/png, application/pdf"
          ></b-form-file>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="
        userConnected.roles.includes('ROLE_INSTRUCTEUR') &&
          request.state.id == 6
      "
    >
      <div
        v-for="document in request.documents"
        v-if="document.typeDocument.nature === 'réception'"
      >
        <div class="line-document">
          {{ document.typeDocument.name }}
          <span class="action"
            ><font-awesome-icon icon="eye" @click="open(document)"
          /></span>
        </div>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-button
          :disabled="isButtonReceptionDisabled"
          @click="validReception"
          variant="primary"
          block
          class="btn-auto pr-5 pl-5"
        >
          Valider
        </b-button>
      </b-col>
      <b-col lg="6" md="10" sm="12" cols="12"></b-col>
      <b-col>
        <b-button
          @click="vModel = false"
          variant="secondary"
          block
          class="btn-auto pr-5 pl-5"
        >
          Annuler
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import router from "../../router/index.js";
import Vuex from "vuex";

export default {
  props: ["value"],
  data() {
    return {
      receptionSelected: {},
      piece3: {
        file: null,
        typeDocument: {},
      },
      piece4: {
        file: null,
        typeDocument: {},
      },
      imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
      pdfMimeType: ["application/pdf"],
      DocMimeType: [
        "application/octet-stream",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "pplication/vnd.oasis.opendocument.text",
        "application/vnd.ms-powerpoint",
        "text/csv",
        "application/vnd.ms-office",
        "text/plain",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.oasis.opendocument.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ],
    };
  },

  async mounted() {
    // await this.getReception(this.request.id);
  },
  methods: {
    open(doc) {
      if (this.imageMimeType.includes(doc.mimeType)) {
        const viewer = this.$el.querySelector(".images" + doc.id).$viewer;
        viewer.show();
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        this.viewerDoc = true;
        this.docToView = doc.url;
      }
    },
    newReception(data) {
      data.requestId = this.request.id;
      data.stateId = 7;
      if (this.request.state.id == 4 || this.request.state.id == 12) {
        if (this.request.state.id == 12) {
          data.stateId = 7;
        }

        const pieces = [this.piece3, this.piece4];

        for (const piece of pieces) {
          if (piece.file !== null) {
            piece.file.requestId = this.request.id;
            piece.file.stdUserId = this.userConnected.id;
            switch (piece) {
              case this.piece3:
                piece.file.typeDocumentId = 104;
                break;
              case this.piece4:
                piece.file.typeDocumentId = 105;
                break;
            }

            this.sendDocument(piece.file);
          }
        }

        this.addReception(data);
      }
    },
    validReception() {
      this.vModel = false;
      this.receptionSelected.option = "Photos";
      this.newReception(this.receptionSelected);
    },
    ...Vuex.mapActions("Cerfa", ["setCerfa14023", "updateCerfa14023"]),
    ...Vuex.mapActions("Document", ["sendDocument"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "addReception",
      "sendToClicmap",
    ]),
  },
  onMounted() {
    if (!this.receptionSelected.option) {
      this.receptionSelected.option = "Photos";
    }
  },
  computed: {
    isButtonReceptionDisabled() {
      let disabled = true;

      const demandeur = this.userConnected.roles.includes("ROLE_DEMANDEUR");
      const instructeur = this.userConnected.roles.includes("ROLE_INSTRUCTEUR");
      const admin = this.userConnected.roles.includes("ROLE_ADMIN");

      if (this.piece3.file != null && this.piece4.file != null) {
        return false;
      }

      return disabled;
    },
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    vModel: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },

    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
};
</script>
